import { render, staticRenderFns } from "./CardBlock.vue?vue&type=template&id=466b1a22&scoped=true&"
import script from "./CardBlock.vue?vue&type=script&lang=js&"
export * from "./CardBlock.vue?vue&type=script&lang=js&"
import style0 from "./CardBlock.vue?vue&type=style&index=0&id=466b1a22&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b1a22",
  null
  
)

export default component.exports